import { render, staticRenderFns } from "./ChangeStatusRecipe.vue?vue&type=template&id=8b2c06dc&"
import script from "./ChangeStatusRecipe.vue?vue&type=script&lang=js&"
export * from "./ChangeStatusRecipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports